import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { GenderEnum } from '../../../models/gender.enum';


export interface UserSearchRequest {
  username: string;
  firstName: string;
  lastName: string;
}

@Component({
  selector: 'app-user-search',
  templateUrl: './user-search.component.html'
})
export class UserSearchComponent implements OnInit {

  userSearchForm: FormGroup;
  genderEnum = GenderEnum;

  @Output() searchUser = new EventEmitter<UserSearchRequest>();

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit() {
    this.buildForm();
  }

  private buildForm() {
    this.userSearchForm = this.formBuilder.group({
      username: new FormControl(null),
      firstName: new FormControl(null),
      lastName: new FormControl(null)
    });
  }

  get f() { return this.userSearchForm.controls; }

  onSubmit() {
    if (this.userSearchForm.invalid) {
        return;
    }

    this.searchUser.emit(this.userSearchForm.value);
  }

  reset() {
    this.userSearchForm.reset();
    this.searchUser.emit(this.userSearchForm.value);
  }
}
